import {Button} from "../../Form/Button/Button";
import {buttonColors} from "../../Pickers/InputTheme";
import {i18n} from "../../../Utils/i18n/i18n";
import React, {useContext, useState} from "react";
import {GridReactContext} from "../../../Utils/DataGridWrapper/GridContext";
import './UserWelcomeMessageCell.scss'
import {Modal} from "../../Smart/Modal/Modal";
import {sendWelcomeMessageAPI} from "../../../Services/api";
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import {MessageTypeSelectionButtons} from "../../Notifications/MessageTypeSelectionButtons/MessageTypeSelectionButtons";
import {MessageTypes} from "../../../Utils/Constants";
import {UserReactContext} from "../../../contexts/UserContext";

export const UserWelcomeMessageCell = ({user: {id: userId, isCompanyAdmin, loginData}}) => {
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [selectedMessagingTypes, setSelectedMessagingTypes] = useState([MessageTypes.SMS])
    const userContext = useContext(UserReactContext)
    const gridContext = useContext(GridReactContext)

    const sendWelcomeMessage = async () => {
        await sendWelcomeMessageAPI({userIdsToSendMessage:[userId], messageTypes:selectedMessagingTypes, companyId:userContext.getUserCompanyId()})
        gridContext.triggerTableRefresh()
        setIsModalOpen(false)
    }
    const onOpenModal = () => {
        setIsModalOpen(true)
    }
    const onModalClose = () => {
        setIsModalOpen(false)
    }

    const onSelectedMessagingTypeChange = (messagingType) => {
        //if it is the only one selected do not remove it
        if (selectedMessagingTypes.includes(messagingType) && selectedMessagingTypes.length > 1) {
            setSelectedMessagingTypes(selectedMessagingTypes.filter((type) => type !== messagingType))
        } else {
            let messagingTypes = [...selectedMessagingTypes, messagingType]
            //uniq array
            messagingTypes = messagingTypes.filter((value, index, self) => self.indexOf(value) === index)
            setSelectedMessagingTypes(messagingTypes)
        }
    }

    return <div className="sendWelcomeMessageModal">
        {!isCompanyAdmin ? <Button color={buttonColors.GREY}
                 size="small"
                 icon={<SendOutlinedIcon/>}
                 onClick={onOpenModal}/> : i18n.translate('createEditUserModal.userIsCompanyAdmin')}
        {isModalOpen ? <Modal open={isModalOpen} onClose={onModalClose}>
            <div className="sendWelcomeMessageModal modalWrapper">
                <div className={"modalContent"}>
                <MessageTypeSelectionButtons onSelectedMessageTypeChange={onSelectedMessagingTypeChange}
                                             selectedMessagingTypes={selectedMessagingTypes}/>
                </div>
                <div className="modalFooter">
                    <Button color={buttonColors.GREY}
                            text={i18n.translate('createEditUserModal.sendWelcomeMessageConfirm')}
                            onClick={sendWelcomeMessage}/>
                    <Button color={buttonColors.YELLOW}
                            text={i18n.translate('general.cancel')}
                            onClick={onModalClose}/>
                </div>
            </div>
        </Modal> : ""}
    </div>
}